import { render, staticRenderFns } from "./pick.vue?vue&type=template&id=88614154&"
import script from "./pick.vue?vue&type=script&lang=js&"
export * from "./pick.vue?vue&type=script&lang=js&"
import style0 from "./pick.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports